"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JobEventDto = exports.JobDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class JobDto {}
exports.JobDto = JobDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], JobDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], JobDto.prototype, "title", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.JobType
}), __metadata("design:type", String)], JobDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.JobStatus
}), __metadata("design:type", String)], JobDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], JobDto.prototype, "interval", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], JobDto.prototype, "timeout", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], JobDto.prototype, "nextRunAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], JobDto.prototype, "createdAt", void 0);
class JobEventDto {}
exports.JobEventDto = JobEventDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], JobEventDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Number)], JobEventDto.prototype, "itemCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], JobEventDto.prototype, "startedTimestamp", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", String)], JobEventDto.prototype, "finishedTimestamp", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", String)], JobEventDto.prototype, "timedOutTimestamp", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], JobEventDto.prototype, "createdAt", void 0);
//# sourceMappingURL=Job.dto.js.map